import { graphql } from "@apollo/client/react/hoc"
import get from "lodash/get"
import { DiscussionsDocument } from "../api/generated"

const FirstDiscussionQuery = (props) => {
  return props.children(props)
}

export default graphql(DiscussionsDocument, {
  options: ({ context, type }) => ({
    variables: { first: 1, context, type }
  }),
  props: ({ data }) => ({
    error: data.error,
    loading: data.loading,
    refetch: data.refetch,
    firstDiscussion: get(data, "discussions.edges[0].node"),
    firstDiscussionId: get(data, "discussions.edges[0].node.id")
  })
})(FirstDiscussionQuery)
